<div *onlyForScreens="screens">
  <div
    class="section"
    *onlyForScreens="['mobile']"
    [class.dark]="style.background === 'dark' || style.background === 'black'"
    [class.black]="style.background === 'black'"
    [class.white]="style.background === 'white'"
  >
    <div
      class="page spacing-top-{{ style.topSpacing }} mobile-spacing-top-{{ style.mobileTopSpacing }} bottomless"
      [style.max-width]="pageWidth ? pageWidth + 'px' : '100%'"
      [appStoryblok]="_editable"
    >
      <h2 class="mobile-compare-plans-title">{{ title }}</h2>
    </div>
  </div>

  <div
    class="section"
    appStickyContainer
    #pricingHeaderContainer
    [class.dark]="style.background === 'dark' || style.background === 'black'"
    [class.black]="style.background === 'black'"
    [class.white]="style.background === 'white'"
  >
    <div
      class="page spacing-bottom-{{ style.bottomSpacing }} mobile-spacing-bottom-{{
        style.mobileBottomSpacing
      }} headless standard-spacing"
      [style.max-width]="pageWidth ? pageWidth + 'px' : '100%'"
      [appStoryblok]="_editable"
    >
      <div class="table" [class.sticky-header]="stickyHeader">
        <ng-container *onlyForScreens="['desktop', 'tablet']">
          <div class="table-header storyblok-table-header">
            <div class="table-row">
              <div class="table-field no-padding">
                <h2>{{ title }}</h2>
              </div>
              <div class="table-field spacing"></div>
              <div
                class="table-field product-name no-padding"
                *ngFor="let _data of comparisons"
                [appStoryblok]="_data._editable"
              >
                <h3 class="style-{{ _data.color }}">
                  <div class="name">{{ _data.name }}</div>
                  <div class="price">
                    {{ _data.price.amount / 12 | customCurrency }}<span *ngIf="_data.price.amount">/mo</span>
                  </div>
                </h3>
              </div>
            </div>
          </div>
        </ng-container>

        <app-sticky
          [container]="pricingHeaderContainer"
          class="pricing-header"
          [paddingX]="0"
          [paddingY]="stickyHeader ? 64 : 0"
          [zIndex]="3"
          *onlyForScreens="['mobile']"
          [fullWidth]="true"
        >
          <div class="table-row table-header storyblok-table-header">
            <div class="table-field spacing"></div>
            <div class="table-field product-name no-padding" *ngFor="let _data of comparisons">
              <h3 class="style-{{ _data.color }}">
                <div class="name">{{ _data.name }}</div>
                <div class="price">
                  {{ _data.price.amount / 12 | customCurrency }}<span *ngIf="_data.price.amount">/mo</span>
                </div>
              </h3>
            </div>
          </div>
        </app-sticky>

        <div *ngFor="let group of featureGroups" class="feature-group">
          <div class="table-row">
            <div class="table-field">
              <h3>{{ group.title }}</h3>
            </div>
          </div>
          <div class="table-row narrow" *ngFor="let feature of group.features">
            <div class="table-field small feature-name">
              <span
                class="feature-name"
                appTooltip=""
                [showOnMobile]="true"
                [tooltipHtmlContent]="feature.text | storyblokRichText"
                [tooltipTitle]="feature.title"
                [tooltipImageUrl]="feature.image?.filename | storyblokCdn"
                [tooltipStyle]="'light'"
                [tooltipSize]="'big'"
                [skipDelay]="true"
                [class.has-hover]="(feature.text | storyblokRichText).length > 10"
                >{{ feature.title }}</span
              >
              <span class="label label-orange in-flex" *ngIf="feature.comingSoon">SOON</span>
              <span class="label label-primary in-flex" *ngIf="feature.new">NEW</span>
            </div>
            <div class="table-field spacing"></div>
            <div
              class="table-field feature-result style-{{ _data.color }}"
              *ngFor="let _data of comparisons"
              [appStoryblok]="_data.features[feature.uuid]['_editable']"
            >
              <ng-container *ngIf="_data.features[feature.uuid]?.customTextValue">
                {{ _data.features[feature.uuid].customTextValue }}
              </ng-container>
              <ng-container *ngIf="!_data.features[feature.uuid]?.customTextValue">
                <app-svg src="/assets/icons/minus.svg" class="faded" *ngIf="!_data.features[feature.uuid]?.value">
                </app-svg>
                <app-svg src="/assets/icons/check-filled.svg" *ngIf="_data.features[feature.uuid]?.value"> </app-svg>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
